import { useCallback, useRef } from 'react';
import getMeta from '@atlassian/jira-get-meta';
import { fg } from '@atlassian/jira-feature-gating';
import type { ExperienceAttributes } from '../../common/types.tsx';
import { useExperienceContext } from '../../common/ui/use-experience-context/index.tsx';

export type Props = {
	experience: string;
	attributes?: ExperienceAttributes;
};

export const useExperienceAbort = ({ experience, attributes }: Props) => {
	const experienceTracker = useExperienceContext();

	const self = useRef({
		name: experience,
		attributes,
		experienceTracker,
	});

	self.current.name = experience;
	self.current.attributes = attributes;
	self.current.experienceTracker = experienceTracker;

	return useCallback(
		(reason: string, extraAttributes: ExperienceAttributes = {}) => {
			const { current } = self;

			let shardAndRegionAttributes: ExperienceAttributes = {};
			if (fg('improve_abortable_errors_experience_tracker')) {
				shardAndRegionAttributes = {
					shard: getMeta('ajs-shard'),
					region: getMeta('ajs-region'),
				};
			}

			current.experienceTracker.abort({
				name: current.name,
				reason,
				attributes: {
					...current.attributes,
					...extraAttributes,
					...shardAndRegionAttributes,
				},
			});
		},
		[self],
	);
};
